import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'

import App from './App.vue'

import HelperMixin from '@/mixins/Helper'

import Menu from '@/pages/Menu'
import SerialNo from '@/pages/SerialNo'
import Payment from '@/pages/Payment'
import Result from '@/pages/Result'
import PageNotFound from '@/pages/PageNotFound'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [{
    path: '/menu',
    component: Menu
  }, {
    path: '/payment',
    component: Payment
  }, {
    path: '/serial-no',
    component: SerialNo
  }, {
    path: '/result',
    component: Result
  }, {
    path: '/page-not-found',
    component: PageNotFound
  }],

  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // 沒帶參數不能進 /menu
  if (to.path === '/menu') {
    const { tk, msn } = to.query
    if (!tk || !msn) {
      router.push({ path: "/page-not-found" })
    }
  }

  // 順序一定要是 /menu 完成後才能進 /payment
  if (to.path === '/payment' && from.path !== '/menu') {
    router.push({ path: "/page-not-found" })
  }

  next()
})

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    deals: [],
    payment_methods: [],

    form: {
      machine_sn: "",
      deal_id: 0,
      payment_method_id: 0,
      serial_no: ""
    }
  },
  mutations: {
    set_deals(state, deals) {
      state.deals = deals
    },
    set_payment_methods(state, payment_methods) {
      state.payment_methods = payment_methods
    },

    set_form_machine_sn(state, form_machine_sn) {
      state.form.machine_sn = form_machine_sn
    },
    set_form_deal_id(state, form_deal_id) {
      state.form.deal_id = form_deal_id
    },
    set_form_payment_method_id(state, form_payment_method_id) {
      state.form.payment_method_id = form_payment_method_id
    },
    set_form_serial_no(state, form_serial_no) {
      state.form.serial_no = form_serial_no
    }
  }
})

Vue.mixin(HelperMixin)

// import UserPaymentMenu from "./components/UserPaymentMenu";
// Vue.component('ccb-user-payment-menu', UserPaymentMenu);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
